var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.5642 9.37895H14.3243L13.9493 8.6C13.777 8.23158 13.4122 8 13.0169 8H11.9527C11.5574 8 11.2027 8.23158 11.0203 8.6L10.6453 9.37895H8.41554C8.19257 9.37895 8 9.56842 8 9.81053C8 10.0526 8.18243 10.2421 8.41554 10.2421H8.93243L9.75338 17.1053C9.81419 17.6211 10.2297 18 10.7365 18H14.2534C14.75 18 15.1655 17.6105 15.2365 17.1053L16.0676 10.2421H16.5845C16.8074 10.2421 17 10.0526 17 9.81053C17 9.56842 16.7973 9.37895 16.5642 9.37895ZM11.7601 8.97895C11.8007 8.90526 11.8716 8.85263 11.9527 8.85263H13.0169C13.098 8.85263 13.1791 8.90526 13.2095 8.97895L13.402 9.38947H11.5676L11.7601 8.97895Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.992c7785787007d85baeab522b792dc3.svg";
export { ForwardRef as ReactComponent };